import { type JSX } from 'react'

import { IconClose } from '@redteclab/icons'

import { useLocaleContext } from 'base-ui'

type NewsletterModalTitleProps = {
  onModalClose: () => void
}

export const NewsletterModalTitle = ({
  onModalClose,
}: NewsletterModalTitleProps): JSX.Element => {
  const closeLabel = useLocaleContext().dialog.close

  return (
    <div className="relative">
      <button
        aria-label={closeLabel}
        className="absolute right-3 top-3 p-0 text-dark-primary-max hover:text-dark-hover-brand active:text-dark-pressed-brand"
        onClick={onModalClose}
        type="button"
      >
        <IconClose aria-hidden className="size-8" />
      </button>
    </div>
  )
}
